/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BatchInvestmentRequestItem } from './BatchInvestmentRequestItem';
import {
    BatchInvestmentRequestItemFromJSON,
    BatchInvestmentRequestItemFromJSONTyped,
    BatchInvestmentRequestItemToJSON,
} from './BatchInvestmentRequestItem';

/**
 * 
 * @export
 * @interface BatchInvestmentRequestCreatePayload
 */
export interface BatchInvestmentRequestCreatePayload {
    /**
     * 
     * @type {Array<BatchInvestmentRequestItem>}
     * @memberof BatchInvestmentRequestCreatePayload
     */
    requests: Array<BatchInvestmentRequestItem>;
}

/**
 * Check if a given object implements the BatchInvestmentRequestCreatePayload interface.
 */
export function instanceOfBatchInvestmentRequestCreatePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "requests" in value;

    return isInstance;
}

export function BatchInvestmentRequestCreatePayloadFromJSON(json: any): BatchInvestmentRequestCreatePayload {
    return BatchInvestmentRequestCreatePayloadFromJSONTyped(json, false);
}

export function BatchInvestmentRequestCreatePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchInvestmentRequestCreatePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requests': ((json['requests'] as Array<any>).map(BatchInvestmentRequestItemFromJSON)),
    };
}

export function BatchInvestmentRequestCreatePayloadToJSON(value?: BatchInvestmentRequestCreatePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requests': ((value.requests as Array<any>).map(BatchInvestmentRequestItemToJSON)),
    };
}

